export default __webpack_public_path__ + "static/media/logo-black-friday-2024.9b50d8b3.svg";